import {
  Button,
  Card,
  Row,
  Col,
  Tag,
  Form,
  Input,
  Select,
  DatePicker,
  Dropdown,
  Menu,
  Divider,
  Badge,
  Table,
  Upload,
  Spin,
  Layout,
  Typography,
  Modal,
  Switch,
  InputNumber,
  Popconfirm,
  message,
  Pagination,
  Tabs,
  Radio,
  Descriptions,
  Collapse,
  Checkbox,
  Empty,
  Steps,
  Drawer,
  Timeline,
  Image,
  Cascader,
  Alert,
  TreeSelect,
  ConfigProvider,
  Space,
  Result,
  Statistic,
  Tooltip,
  StyleProvider,
  QRCode,
  Slider,
  Watermark,
} from "ant-design-vue";

/**
 * @description 手动注册 antd-vue 组件,达到按需加载目的
 * @description Automatically register components under Button, such as Button.Group
 * @param {ReturnType<typeof createApp>} app 整个应用的实例
 * @returns void
 */
export default function loadComponent(app: any) {
  app.use(Button);
  app.use(Card);
  app.use(Row);
  app.use(Col);
  app.use(Tag);
  app.use(Form);
  app.use(Input);
  app.use(Dropdown);
  app.use(Menu);
  app.use(Divider);
  app.use(ConfigProvider);
  app.use(Select);
  app.use(DatePicker);
  app.use(Badge);
  app.use(Table);
  app.use(Upload);
  app.use(Spin);
  app.use(Layout);
  app.use(Typography);
  app.use(Modal);
  app.use(Switch);
  app.use(InputNumber);
  app.use(Popconfirm);
  app.use(Pagination);
  app.use(Tabs);
  app.use(Radio);
  app.use(Descriptions);
  app.use(Collapse);
  app.use(Checkbox);
  app.use(Empty);
  app.use(Steps);
  app.use(Drawer);
  app.use(Timeline);
  app.use(Image);
  app.use(Cascader);
  app.use(Alert);
  app.use(TreeSelect);
  app.use(Space);
  app.use(Result);
  app.use(Statistic);
  app.use(Tooltip);
  app.use(StyleProvider);
  app.use(QRCode);
  app.use(Slider);
  app.use(Watermark);
  app.config.globalProperties.$message = message;
}
